require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2084],{

/***/ 61422:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _reactMeasure = _interopRequireDefault(__webpack_require__(9597));
var _utils = __webpack_require__(78815);
var _lodash = __webpack_require__(46517);
var _TruncatedText = _interopRequireDefault(__webpack_require__(28127));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui--carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const truncatedTextClassName = _TruncatedText.default.truncatedTextClassName.replace(/"/g, '');
const CHAR_THRESHOLD = 4;
const {
  sanitize,
  BaPropTypes
} = _utils.propsUtils;
const {
  resolveBaseTextDir
} = _utils.bidiUtils;
class TruncatedText extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      charCount: this._handleValueType().length
    });
    (0, _defineProperty2.default)(this, "onMeasure", dimensions => {
      if (this.state.isMounted) {
        const containerWidth = Math.ceil(dimensions.entry.width);
        this._resizeText(containerWidth);
      } else {
        this._getTextWidths();
      }
    });
    (0, _defineProperty2.default)(this, "getTextNode", () => {
      const {
        textDir
      } = this.props;
      const value = this._handleValueType();
      const {
        charCount
      } = this.state;
      const initCharCount = value.length;
      const isEllipsed = charCount >= 0 && charCount < initCharCount;
      let ellipsisValue = '';
      if (isEllipsed) {
        if (charCount <= 1) {
          ellipsisValue = '\u2026';
        } else {
          const charStart = Math.floor(charCount / 2);
          const charEnd = initCharCount - Math.ceil(charCount / 2) + 1;
          ellipsisValue = this.props.location === 'middle' ? `${value.substring(0, charStart)}\u2026${value.substring(charEnd)}` : `${value.substring(0, charCount - 3)}\u2026`;
        }
      } else {
        ellipsisValue = _utils.Bidi.reshape(value, this.props.numShape);
      }
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        "data-tid": "ba-common-truncated-text__text-node",
        className: `${(0, _utils.classnames)(`${truncatedTextClassName}__text`)}`,
        ref: this._refText,
        dir: resolveBaseTextDir(ellipsisValue, textDir, false)
      }, this.mappedTitle(isEllipsed, value), this.ariaLabelAndRole(value)), ellipsisValue);
    });
    (0, _defineProperty2.default)(this, "ariaLabelAndRole", value => {
      const {
        hideAria,
        title
      } = this.props;
      if (hideAria) {
        return {};
      }
      return {
        'aria-label': title || value,
        role: 'region'
      };
    });
    (0, _defineProperty2.default)(this, "mappedTitle", (isEllipsed, value) => {
      const {
        title,
        allowTooltip,
        alwaysShowTooltip
      } = this.props;
      if (!allowTooltip) {
        return {};
      }
      if (alwaysShowTooltip && title) {
        return {
          title
        };
      }
      if (isEllipsed) {
        return {
          title: title || value
        };
      }
    });
    (0, _defineProperty2.default)(this, "_getTextWidths", () => {
      const value = this._handleValueType();
      // get initial widths and char counts
      if (this._textNode) {
        this._textWidth = this._textNode.offsetWidth;
        this._initTextWidth = this._textNode.offsetWidth;
        this._initCharCount = value.length;
        this._initCharWidth = this._getCharWidth(value.length);
        this._lastTruncPos = this._initTextWidth;
        this.setState({
          isMounted: true,
          isHidden: this._textNode.offsetWidth === 0
        });
      }
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
      this._measureRef(node);
    });
    (0, _defineProperty2.default)(this, "_refText", node => {
      this._textNode = node;
    });
    this.debouncedResizeText = (0, _lodash.debounce)(this._resizeText, 10);
  }
  componentDidMount() {
    // Defect 234641: Added._textNode.offsetWidth condition check to prevent truncated text with 0 max width
    if (!this._textNode.offsetWidth) {
      setTimeout(this._getTextWidths);
    } else {
      this._textNode && this._getTextWidths();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      // reset charCount to trigger measuring again
      const nextValueProp = this._handleValueType(nextProps.value);
      this.setState({
        charCount: nextValueProp.length,
        isMounted: false,
        isHidden: true
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.isMounted) {
      const containerWidth = this._node.offsetWidth;
      this._textWidth = this._textNode.offsetWidth;
      if (prevState.isMounted !== this.state.isMounted) {
        // check if resizing is still needed after first render
        this.debouncedResizeText(containerWidth);
      } else if (prevState.charCount !== this.state.charCount) {
        // keep track of position when last truncation was made
        this._lastTruncPos = containerWidth;
        if (containerWidth < this._textWidth) {
          // keep resizing until textWidth is < container
          this._shortenText(containerWidth);
        }
      }
    } else if (prevProps.value !== this.props.value) {
      // trigger measuring after updating props (i.e. in Select)
      this._getTextWidths();
    }
  }
  componentWillUnmount() {
    this.debouncedResizeText && this.debouncedResizeText.cancel();
  }
  _handleValueType(value) {
    if (value === void 0) {
      value = this.props.value;
    }
    return value == null ? '' : String(value);
  }
  _resizeText(containerWidth) {
    if (containerWidth < this._textWidth && containerWidth < this._lastTruncPos) {
      this._shortenText(containerWidth);
    } else if (containerWidth > this._textWidth && containerWidth < this._initTextWidth && containerWidth > this._lastTruncPos) {
      this._lengthenText(containerWidth);
    } else if (containerWidth >= this._initTextWidth && this.state.charCount !== this._initCharCount) {
      // show entire string by resetting charCount
      this._lastTruncPos = this._initTextWidth;
      this.setState({
        charCount: this._initCharCount
      });
    }
  }
  _shortenText(containerWidth) {
    const {
      charCount
    } = this.state;
    if (charCount > 0 && containerWidth > 0) {
      const charWidth = this._getCharWidth(charCount);
      const extraChars = this._getExcessChars(containerWidth, charWidth);
      const newCharCount = Math.max(0, charCount - Math.max(1, extraChars));
      this.setState({
        charCount: newCharCount
      });
    }
  }
  _lengthenText(containerWidth) {
    const value = this._handleValueType();
    const {
      charCount
    } = this.state;
    if (charCount < value.length) {
      const charWidth = this._getCharWidth(charCount);
      const diff = containerWidth - this._textWidth;
      const missingChars = this._getExcessChars(containerWidth, charWidth);
      if (diff > 1.5 * charWidth || value.length - charCount === 1) {
        const newCharCount = Math.min(value.length, charCount + missingChars);
        if (newCharCount !== charCount) {
          this.setState({
            charCount: newCharCount
          });
        }
      }
    }
  }
  _getCharWidth(charCount) {
    return charCount > CHAR_THRESHOLD ? this._textWidth / charCount : this._initCharWidth;
  }
  _getExcessChars(containerWidth, charWidth) {
    const extraChars = Math.floor((this._textWidth - containerWidth) / charWidth);
    return Math.abs(extraChars);
  }
  render() {
    const {
      className,
      textAlign,
      style,
      disabled,
      ...others
    } = this.props;
    const {
      isMounted,
      isHidden
    } = this.state;
    const containerStyle = {
      textAlign,
      // Defect 226704: Added the fallback inline styles
      // Defect 234641: Added _initTextWidth as part of condition check
      maxWidth: isMounted && this._initTextWidth !== 0 ? this._initTextWidth + 2 : '100%',
      // Defect BAUICOMMON-783: using block to display the KPI Indicator when offsetWidth is 0
      display: isMounted && !isHidden ? 'table' : 'block',
      // visibility: _isMounted ? 'visible' : 'hidden',
      ...style
    };
    const classNames = (0, _utils.classnames)(truncatedTextClassName, {
      disabled
    });
    return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
      onResize: this.onMeasure
    }, _ref => {
      let {
        measureRef
      } = _ref;
      this._measureRef = measureRef;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, TruncatedText), {
        className: `${classNames} ${className}`,
        ref: this._ref,
        style: {
          ...containerStyle
        }
      }), this.getTextNode());
    });
  }
}
exports["default"] = TruncatedText;
(0, _defineProperty2.default)(TruncatedText, "propTypes", {
  value: _propTypes.default.string.isRequired,
  location: _propTypes.default.oneOf(['end', 'middle']),
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  numShape: _propTypes.default.bool,
  style: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  allowTooltip: _propTypes.default.bool,
  tooltipDelay: BaPropTypes.deprecated('deprecated - browser tooltip is used '),
  alwaysShowTooltip: _propTypes.default.bool,
  hideAria: _propTypes.default.bool
});
(0, _defineProperty2.default)(TruncatedText, "defaultProps", {
  location: 'middle',
  className: '',
  style: {},
  allowTooltip: true
});

/***/ }),

/***/ 21210:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _TruncatedText = _interopRequireDefault(__webpack_require__(61422));
exports["default"] = _TruncatedText.default;
exports.TruncatedText = _TruncatedText.default;

/***/ }),

/***/ 67221:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-truncatedText{overflow:hidden;white-space:nowrap;width:100%;display:table;table-layout:fixed;text-decoration:inherit}.ba-common-truncatedText__text{white-space:nowrap;line-height:normal;display:inline-block;text-decoration:inherit}.ba-common-truncatedText__tooltip{width:100%}.ba-common-truncatedText.is-disabled{cursor:not-allowed}.ba--highContrast .ba-common-truncatedText.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-truncatedText{transition:opacity .2s ease-in-out}.ba-common-truncatedText.is-disabled{opacity:.5}", ""]);

// exports
exports.locals = {
	"truncatedTextClassName": "\"ba-common-truncatedText\""
};

/***/ }),

/***/ 28127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67221);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TruncatedText_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 46517:
/***/ ((module) => {

"use strict";
module.exports = require("lodash");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 9597:
/***/ ((module) => {

"use strict";
module.exports = require("react-measure");

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(21210));
/******/ return __webpack_exports__;
/******/ }
]);
});